<template> <!-- Ассортимент -->
  <div>
    <!-- Спинер -->
    <div
      class="my-4 text-center"
      v-if="stockTreeSelectedFetching || getStockTreeFetching"
    >
      <slot name="loader"></slot>
    </div>
    <div v-else>
      <v-overlay color="white" :value="stockTreeSelectedUpdating" absolute>
        <v-progress-circular
          :size="50"
          color="indigo lighten-4"
          indeterminate
        ></v-progress-circular>
      </v-overlay>

      <div class="subtitle-1 font-weight-medium">Выберите нужные разделы:</div>

      <!-- Чекбокс вкл/выкл всех -->
      <v-checkbox
        label="Все элементы"
        class="mt-1"
        @change="switchAll"
        dense
        hide-details
      ></v-checkbox>
      <v-treeview
        :items="getStockRootTree"
        :active="activeItems"
        selection-type="independent"
        class="pb-3 pt-2"
        multiple-active
        hoverable
        open-on-click
        dense
      >
        <template #prepend="{ item }">
          <SelectTreeChildsDialog @select="checkboxHandler(item, $event)">
            <template v-slot:activator="{on, attrs}">
              <v-checkbox
                :input-value="item.selected"
                class="ma-0 pa-0 tree_checkbox"
                hide-details
                dense
                v-on="on"
                v-bind="attrs"
              ></v-checkbox>
            </template>
          </SelectTreeChildsDialog>
        </template>
        <template #label="{ item }">
          <span :class="!item.enabled && 'grey--text darken-3'">
            {{ item.name }}
          </span>
        </template>
      </v-treeview>
      <slot
        name="actions"
        :resetChanges="resetChanges"
        :saveChanges="saveChanges"
        :hasChanges="hasChanges"
      ></slot>
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapActions, mapState } from 'vuex'
import SelectTreeChildsDialog from "@/components/SelectTreeChildsDialog";

const itemIsActive = item => {
  if (item.selected) {
    return true
  } else if (item.children) {
    return item.children.some(itemIsActive)
  }
  return false
}

export default {
  components: {
    SelectTreeChildsDialog
  },
  mounted() {
    this.actionFetchStockTree()
    if (this.activeDistributor) {
      this.actionFetchSelectedStockTree(this.activeDistributor)
    }
  },
  watch: {
    // Загрузка категорий при загрузке страницы и смене поставщика
    activeDistributor: function(distributorId) {
      if (distributorId) {
        this.actionFetchSelectedStockTree(distributorId)
      }
    }
  },
  computed: {
    ...mapGetters('app_aggregator', ['activeDistributor']),
    ...mapState('stock_tree', {
      stockTreeSelectedFetching: state => state.stock_tree_selected_fetching,
      stockTreeSelectedUpdating: state => state.stock_tree_selected_updating
    }),
    ...mapGetters('stock_tree', [
      'getStockTreeSelected',
      'getStockTreeItemsTree',
      'getStockTreeChildsIdRecursive',
      'getStockRootTree',
      'getStockTreeFetching'
    ]),
    activeItems: function() {
      return this.getStockTreeItemsTree.length
        ? this.getStockTreeItemsTree
            .filter(item => itemIsActive(item))
            .map(item => item.id)
        : []
    },
    selectedItems: function() {
      return (
        this.getStockTreeSelected.changed || this.getStockTreeSelected.default
      )
    },
    hasChanges: function() {
      return this.getStockTreeSelected.changed
        ? !_.isEqual(
            _.sortBy(this.getStockTreeSelected.changed),
            _.sortBy(this.getStockTreeSelected.default)
          )
        : false
    }
  },
  methods: {
    ...mapActions('stock_tree', [
      'actionFetchStockTree',
      'actionFetchSelectedStockTree',
      'actionUpdateSelectedStockTree',
      'actionSetStockTreeSelected'
    ]),
    checkboxHandler: function(item, selectChilds) {
      let checked = this.selectedItems.includes(item.id)
      let selectedItems = []
      if (selectChilds) {
        selectedItems = checked
          ? _.difference(this.selectedItems, [
              item.id,
              ...this.getStockTreeChildsIdRecursive(item.id)
            ])
          : _.concat(this.selectedItems, [
              item.id,
              ...this.getStockTreeChildsIdRecursive(item.id)
            ])
      } else {
        selectedItems = checked
          ? _.difference(this.selectedItems, [item.id])
          : _.concat(this.selectedItems, [item.id])
      }
      this.actionSetStockTreeSelected({ changed: selectedItems })
    },
    // Кнопка отмена изменений
    resetChanges: function() {
      this.actionSetStockTreeSelected({ changed: null })
    },
    // Кнопка сохранить изменения
    saveChanges: function() {
      this.actionUpdateSelectedStockTree({
        distributorId: this.activeDistributor,
        toggleOn: _.difference(
          this.getStockTreeSelected.changed,
          this.getStockTreeSelected.default
        ),
        toggleOff: _.difference(
          this.getStockTreeSelected.default,
          this.getStockTreeSelected.changed
        )
      }).then(() => {
        this.actionSetStockTreeSelected({
          default: this.getStockTreeSelected.changed,
          changed: null
        })
      })
    },
    // Вкл/Выкл все записи
    switchAll: function(value) {
      this.actionSetStockTreeSelected({
        changed: value ? this.getStockTreeItemsTree.map(item => item.id) : null
      })
    }
  }
}
</script>
